export function AudienceWelcome({ currentTopicId }: { currentTopicId: string | null }) {
  return (
    <div className="page audience-welcome">
      <section className="welcome-panel" aria-labelledby="welcome-title">
        <span className="welcome-mark" aria-hidden="true" />
        <h1 id="welcome-title">Welcome to Panther Meeting 2026</h1>
        {!currentTopicId && <p>Please wait for the first presentation to begin.</p>}
      </section>
    </div>
  );
}
